export default __webpack_public_path__ + "static/media/alfan_logo.5eee3a34.svg";